module.exports = __webpack_public_path__ + "static/media/rum.a8ac0b45.jpg";